import * as XLSX from 'xlsx';
import { buildExportAoA, buildExportFilename } from './icerikExcelEditTemplates';

/**
 * @param {'urun'|'parca'|'islem'} icerikTipi
 * @param {{ type: 'kategori', kategoriId: string } | { type: 'urun', urunIcerikId: string }} scope
 * @param {object[]} items
 */
export const downloadIcerikEditExcel = (icerikTipi, scope, items) => {
  const aoa = buildExportAoA(icerikTipi, scope, items);
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Duzenle');
  const fname = buildExportFilename(icerikTipi, scope);
  XLSX.writeFile(wb, fname, { compression: true });
  return fname;
};
